import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveBaraemAnswersRequest } from '../../../services/liferay/baraemServices';

const AppointmentForm = ({ setQuestionStep, questions = [], baraemUsername, hcNumber, questionnaireid, translationMap }) => {
  const navigate = useNavigate();
  const [responses, setResponses] = useState({});

  const reasons = [
  "I will follow with my child's private pediatrician",
  "I will follow in my home country",
  "I don't feel that my child has a problem",
  "Other"];


  const handleResponseChange = (questionId, reason, questionText, questionI18n) => {
    setResponses((prev) => ({
      ...prev,
      [questionId]: {
        answer: reason,
        answertext: "", // No additional text input in this form
        baraemusername: baraemUsername,
        hasConcern: 0, // Assuming no concern for this form
        hcnumber: hcNumber,
        isactive: 1,
        isFeedback: 0,
        isScheduleAppointment: 0, // Marking as not scheduling an appointment
        questionid: questionId || null,
        questionnaireid,
        questiontext: questionText || "Reason for not scheduling an appointment",
        questiontext_i18n: questionI18n || {} // Add translations if available
      }
    }));
  };

  const handleSubmit = async () => {
    const formattedResponses = Object.values(responses); // Convert object to array

    // Perform API submission or handle the data as required

    const feedbackResponse = await saveBaraemAnswersRequest(formattedResponses);
    if (feedbackResponse.status === 200)
    {
      navigate("/");
    } else {

    }
  };

  return (
    <div>
            <div
        className="modal fade Custom_Modal_Box show"
        id="skipscheduleappointment"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
                <div className="modal-dialog  CoveragePlan_Dialog3" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="Title_Inner_Box">
                                <h6 className="MainTitleOne">{translationMap?.skipScheduleApp ?? "Skip Schedule Appointment"}</h6>
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="baraem_modal_body">
                                <div className="congrates_inner_box">
                                    <h6 className="Gray_Title">Reasons</h6>
                                    {questions.map((question, index) =>
                  <div key={index} className="question_box">
                                            <p className="para_txt1">{question.question || `Question ${index + 1}`}</p>
                                            <form className="radio_form">
                                                {reasons.map((reason, reasonIndex) =>
                      <div className="radio_box" key={reasonIndex}>
                                                        <input
                          type="radio"
                          id={`reason${index}_${reasonIndex}`}
                          name={`radio-group-${index}`}
                          onChange={() =>
                          handleResponseChange(
                            question.id,
                            reason,
                            question.question,
                            question.question_i18n
                          )
                          } />
                        
                                                        <label htmlFor={`reason${index}_${reasonIndex}`}>{reason}</label>
                                                    </div>
                      )}
                                            </form>
                                        </div>
                  )}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer modal_footer_btn_box3">
                            <button type="button" className="btn blue_btn_link" onClick={handleSubmit}>
                                {translationMap?.submit ?? "Submit"}
                            </button>
                            <button type="button" className="btn bluetrans_btn_link" onClick={() => setQuestionStep(8)}>
                                {translationMap?.goBack ?? "Go Back"}
                            </button>
                            <button type="button" className="btn view_btn_link" data-dismiss="modal" onClick={() => navigate("/")}>
                                {translationMap?.close ?? "Close"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>);

};

export default AppointmentForm;